import React from 'react';
import { Link } from 'react-router-dom';
import { 
  User, 
  MapPin, 
  FileText, 
  Phone, 
  Calendar, 
  Camera, 
  Navigation, 
  Clock,
  CheckCircle,
  AlertCircle
} from 'lucide-react';

const DossierCard = ({ dossier, showActions = true, showProgress = true }) => {
  const getStatutBadge = (statut) => {
    const badges = {
      'en_attente_acceptation': { class: 'badge-info', label: 'Attribué', icon: Clock },
      'en_cours': { class: 'badge-warning', label: 'En cours', icon: Clock },
      'cloture': { class: 'badge-success', label: 'Terminé', icon: CheckCircle }
    };
    return badges[statut] || { class: 'badge-secondary', label: statut, icon: AlertCircle };
  };

  const getPrioriteColor = (priorite) => {
    const colors = {
      'basse': 'text-atl-green-600',
      'normale': 'text-port-gray-600',
      'haute': 'text-red-600'
    };
    return colors[priorite] || 'text-port-gray-600';
  };

  const getAvancementColor = (avancement) => {
    if (avancement === 0) return 'bg-port-gray-300';
    if (avancement < 50) return 'bg-red-500';
    if (avancement < 100) return 'bg-yellow-500';
    return 'bg-atl-green-500';
  };

  const statutBadge = getStatutBadge(dossier.statut);
  const StatutIcon = statutBadge.icon;

  return (
    <Link
      to={`/enqueteur/dossier/${dossier.id}`}
      className="block bg-white rounded-lg shadow-sm border border-port-gray-200 hover:shadow-md transition-shadow"
    >
      <div className="p-4">
        {/* Header de la carte */}
        <div className="flex justify-between items-start mb-3">
          <div>
            <h3 className="font-medium text-atl-blue-600 text-sm">
              {dossier.reference}
            </h3>
            <p className="text-xs text-port-gray-500">
              {dossier.client}
            </p>
          </div>
          
          <div className="flex flex-col items-end space-y-1">
            <span className={`badge ${statutBadge.class} text-xs`}>
              <StatutIcon className="h-3 w-3 mr-1" />
              {statutBadge.label}
            </span>
          </div>
        </div>

        {/* Informations principales */}
        <div className="space-y-2 mb-3">
          <div className="flex items-center text-sm text-port-gray-900">
            <User className="h-4 w-4 text-port-gray-400 mr-2 flex-shrink-0" />
            <span>{dossier.assure.prenom} {dossier.assure.nom}</span>
          </div>
          
          <div className="flex items-center text-sm text-port-gray-600">
            <MapPin className="h-4 w-4 text-port-gray-400 mr-2 flex-shrink-0" />
            <span className="truncate">{dossier.lieu}</span>
          </div>
          
          <div className="flex items-center text-sm text-port-gray-600">
            <FileText className="h-4 w-4 text-port-gray-400 mr-2 flex-shrink-0" />
            <span>{dossier.typeSinistre} - {dossier.natureSinistre}</span>
          </div>
        </div>

        {/* Footer avec actions rapides */}
        {showActions && (
          <>
            <div className="flex justify-between items-center pt-3 border-t border-port-gray-100">
              <div className="flex items-center text-xs text-port-gray-500">
                <Calendar className="h-3 w-3 mr-1" />
                <span>
                  {new Date(dossier.dateSinistre).toLocaleDateString('fr-FR')}
                </span>
              </div>
              
              <div className="flex space-x-2">
                {dossier.assure.telephone && (
                  <a
                    href={`tel:${dossier.assure.telephone}`}
                    className="p-2 text-atl-green-600 hover:bg-atl-green-100 rounded-lg transition-colors"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Phone className="h-4 w-4" />
                  </a>
                )}
                
                <button
                  className="p-2 text-atl-blue-600 hover:bg-atl-blue-100 rounded-lg transition-colors"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Camera className="h-4 w-4" />
                </button>
                
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(dossier.lieu)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 text-port-gray-600 hover:bg-port-gray-100 rounded-lg transition-colors"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Navigation className="h-4 w-4" />
                </a>
              </div>
            </div>

          </>
        )}
      </div>
    </Link>
  );
};

export default DossierCard;

